module.exports = __webpack_public_path__ + "static/media/Campus-Active-Dark.e752f1f1.svg";